import { ThemeSet } from "../../types";
import { generateThemeFromPalette } from "../../utils";
import { plurallPalette } from "../palette/plurallPalette";

const plurallLightTheme = generateThemeFromPalette(plurallPalette, "light");
const plurallDarkTheme = generateThemeFromPalette(plurallPalette, "dark");

export const plurall: ThemeSet = {
  light: {
    ...plurallLightTheme
  },
  dark: {
    ...plurallDarkTheme
  }
};
